import axios from 'axios';

import mockPaData from './mock-data/par-records-data'
import mockDrugListData from './mock-data/drug-list'
import mockDrugFormData from './mock-data/drug-form'
import mockNpiData from './mock-data/npi-data'
import mockTrialData from './mock-data/trial-data'
import mockCreatePaData from './mock-data/create-pa'
import mockUpdatePaData from './mock-data/update-pa-data'
import mockCancelPaData from './mock-data/cancel-pa'
import mockFeatureData from './mock-data/feature-info'

const PA_PROCESS_ENDPOINT  = '/medicalrxservice/par/process'
const USER_INFO_ENDPOINT   = '/medicalrxservice/api/user-info'
const FEATURE_INFO_ENDPOINT   = '/medicalrxservice/api/feature'
const UPLOAD_PA_ENDPOINT_PRE  = '/medicalrxservice/api/doc'
const UPLOAD_PA_ENDPOINT_SUF = 'upload'
const DRUG_INFO_ENDPOINT = '/medicalrxservice/drug/list'
const DRUG_FORM_ENDPOINT = '/medicalrxservice/drug/form'
const MEMBER_LOOKUP_ENDPOINT = '/medicalrxservice/par/memberEligibility'
const DRUG_ELIGIBILITY_ENDPOINT = '/medicalrxservice/par/trial'
const CANCEL_PA_ENDPOINT = '/medicalrxservice/par/cancel'
const UPDATE_PA_ENDPOINT = '/medicalrxservice/par/update'
const CREATE_PA_ENDPOINT = '/medicalrxservice/par/create'

// allow the api to use mock data instead of using api calls
const isMock = process.env.REACT_APP_API_MODE === 'mock';

// default prod user facing error message
const prodErrorResponse = 'There was an error. Please try again.';

// determine which error message to show based on if app is in mock mode
const getError = err => isMock ? err : {...err, message: prodErrorResponse};

// intercept each response and handle error
axios.interceptors.response.use(
    async response => response,
    async error => Promise.reject(getError(error))
    )

export async function fetchPaInfo(payload){
    const {data} = isMock ? {data: mockPaData} : await axios.post( PA_PROCESS_ENDPOINT, payload );
    return data;
}

export async function fetchUserInfo(npi){
    const {data} = isMock ? {data: mockNpiData} : await axios.get( `${USER_INFO_ENDPOINT}/${npi}` );
    return data;
}

export async function fetchFeatureInfo(){
    const {data} = isMock ? {data: mockFeatureData} : await axios.get( FEATURE_INFO_ENDPOINT );
    return data;
}

export async function fetchDrugList(){
    const {data} = isMock ? {data: mockDrugListData} : await axios.get( DRUG_INFO_ENDPOINT );
    return data;
}

export async function fetchDrugForm({drugLabelName = null, searchBy, ndc = null}){
    const {data} = isMock ? {data: mockDrugFormData} :  await axios.get( `${DRUG_FORM_ENDPOINT}?drugLabelName=${drugLabelName}&searchBy=${searchBy}&ndc=${ndc}` );
    return data;
}

export async function fetchMember(params){
    const {data} = isMock ? {data: mockTrialData} :  await axios.post( MEMBER_LOOKUP_ENDPOINT, params );
    return data;
}

export async function fetchEligibility(params){
    const {data} = isMock ? {data: mockTrialData} :  await axios.post( DRUG_ELIGIBILITY_ENDPOINT, params );
    return data;
}

export async function uploadPaAttachments(npi, authNumber, files, data){
    const json = JSON.stringify(data);
    const body = new FormData();
    files.forEach( f => body.append('files', f))
    body.append('uploadPayload', json)
    return axios.post(`${UPLOAD_PA_ENDPOINT_PRE}/${npi}/${authNumber}/${UPLOAD_PA_ENDPOINT_SUF}`, body);
}

export async function cancelPa(payload){
    if(isMock){
        return mockCancelPaData
    }
    const {data} = await axios.post( CANCEL_PA_ENDPOINT, payload )
    return data
}

export async function updatePa(payload){
    if(isMock){
        return mockUpdatePaData
    }
    const {data} = await axios.post( UPDATE_PA_ENDPOINT, payload )
    return data;
}

export async function createPa({createPayload, files}){
    if(isMock){
        return mockCreatePaData
    }
    const json = JSON.stringify(createPayload);
    const body = new FormData();
    files.forEach( f => body.append('files', f))
    body.append('createPayload', json)
    const {data} = await axios.post( CREATE_PA_ENDPOINT, body )
    return data;
}

